import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { changeLang, selectedVoice } from "../langSlice";
import { userLoggedIn, userLoggedOut } from "../auth/authSlice";
import { toast } from "react-toastify";
import { red } from "@mui/material/colors";
import { redirect } from "react-router-dom";
import CryptoJS from "crypto-js";

const LOGIN_GUARD_MS = 30 * 1000;
const LOGIN_ENDPOINTS = new Set([
  "admin-login",
  "school-login",
  "faculty-login",
  "faculty-login-password",
  "get-otp",
  "get-faculty-otp",
]);

const getEndpointPath = (args) => {
  if (typeof args === "string") return args;
  return args?.url || "";
};

const isLoginEndpoint = (args) => LOGIN_ENDPOINTS.has(getEndpointPath(args));

const rawBaseQuery = fetchBaseQuery({
  baseUrl: "https://ecoclubs.education.gov.in/api/",
});

const baseQueryWithLoginGuard = async (args, api, extraOptions) => {
  if (!isLoginEndpoint(args)) {
    return rawBaseQuery(args, api, extraOptions);
  }

  const timeoutResult = await Promise.race([
    rawBaseQuery(args, api, extraOptions),
    new Promise((resolve) =>
      setTimeout(
        () =>
          resolve({
            error: {
              status: "TIMEOUT_ERROR",
              data: { message: "Login request timed out. Please try again." },
            },
          }),
        LOGIN_GUARD_MS
      )
    ),
  ]);
  return timeoutResult;
};


const decryptUser = (encryptedUser) => {
  const secretKey = "EcoClubsForMissionLiFEAICTEADMIN1@1234SecretKey";
  try {
      const bytes = CryptoJS.AES.decrypt(encryptedUser, secretKey);
      const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
      if (!decryptedString) {
          throw new Error("Decryption failed: Empty or invalid data");
      }
      const decryptedUser = JSON.parse(decryptedString);
      return decryptedUser;
  } catch (error) {
      console.error("Decryption failed:", error);
      throw new Error("Failed to decrypt user data.");
  }
};

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithLoginGuard,
  endpoints: (builder) => ({
    refreshToken: builder.query({
      query: (data) => ({
        url: "refresh",
        method: "GET",
        credentials: "include",
      }),

    }),
    loadUser: builder.query({
      query: (data) => ({
        url: "me",
        method: "GET",
        credentials: "include" ,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          const decryptedUser = decryptUser(result.data.user);
          dispatch(
            userLoggedIn({
              accessToken: result.data.accessToken,
              user: decryptedUser,
            })
          );
          dispatch(changeLang(result.data.user.lang));
          dispatch(selectedVoice(result.data.user.voice));
        } catch (error) {
          // alert("Invalid Credentials");
          dispatch(
            userLoggedIn({
              user: "",
              lang: "en-IN"
            })
          );
          redirect("/");
          // toast.error("Session expired. Please login again.");a
          dispatch(userLoggedOut());
          console.log(error);
        }
      },
    }),
  }),
});


export const { useRefreshTokenQuery, useLoadUserQuery } = apiSlice;
